import { ProductCoupon } from '@/domains/loyalty/components/Coupon/ProductCoupon';
import { useDetail } from '@/domains/productDiscovery/ProductPage/hooks/useDetail';
import { useQuantity } from '@/productDiscovery/ProductPage/hooks/useQuantity';

export const MainCoupon = () => {
  const quantity = useQuantity();
  const { price, productId, isSellable } = useDetail();

  if (!isSellable) return null;

  return (
    <ProductCoupon
      context="product page"
      productId={productId ?? 0}
      quantity={quantity}
      unitPrice={price?.primaryPrice.amountWithVat || 0}
    />
  );
};
